import { Form, Popup } from "devextreme-react";
import {
  ButtonItem,
  EmailRule,
  FormRef,
  Label,
  RequiredRule,
  SimpleItem,
} from "devextreme-react/form";
import notify from "../../lib/notify";
import { FormEvent, useCallback, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import axios from "../../lib/axios";

type ChangeUserEmailPopupProps = {
  userId: number;
  onClose: (emailChanged: boolean) => void;
};

export default function ChangeUserEmailPopup({
  userId,
  onClose,
}: ChangeUserEmailPopupProps) {
  const { t } = useTranslation();
  const formRef = useRef<FormRef>(null);
  const [formDisabled, setFormDisabled] = useState(false);

  const handleSubmit = useCallback(
    async (event: FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      const formData = formRef.current?.instance().option("formData");

      setFormDisabled(true);

      try {
        await axios.post("/api/auth/change-email-by-administrator", {
          userId,
          email: formData.email,
        });

        onClose(true);
      } catch (error) {
        notify(
          "Wystąpił błąd podczas próby zmiany adresu e-mail do konta użytkownika.",
          "error"
        );
      } finally {
        setFormDisabled(false);
      }
    },
    [userId, onClose]
  );

  return (
    <Popup
      visible
      title={t("changeUserEmailPopup.title")}
      onHiding={() => onClose(false)}
      maxWidth={500}
      height="auto"
      maxHeight="80vh"
      showCloseButton
      dragEnabled
    >
      <form onSubmit={handleSubmit}>
        <Form
          ref={formRef}
          defaultFormData={{
            email: "",
          }}
          disabled={formDisabled}
        >
          <SimpleItem dataField="email">
            <Label text={t("emailAddress")} />
            <RequiredRule />
            <EmailRule />
          </SimpleItem>
          <ButtonItem
            buttonOptions={{
              useSubmitBehavior: true,
              type: "default",
              text: t("changeEmailAddress"),
            }}
          />
        </Form>
      </form>
    </Popup>
  );
}
